import { render } from "./CompNavbar.vue?vue&type=template&id=6152d882"
import script from "./CompNavbar.vue?vue&type=script&lang=js"
export * from "./CompNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__